"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var T = _interopRequireWildcard(require("prop-types"));
var _reactIntl = require("react-intl");
var _reactRouterDom = require("react-router-dom");
function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/*
 * AutoIntl makes it easy and cleaner to create potentially localized messages
 * without having to check for internationalization and not having to pass back
 * functional components as children.
 */

function filterProps(props, ownProps) {
  const filteredProps = {
    ...props
  };
  for (let prop of ownProps) {
    delete filteredProps[prop];
  }
  return filteredProps;
}
const elements = {
  a(props, msg) {
    return /*#__PURE__*/_react.default.createElement("a", props, msg);
  },
  button(props, msg) {
    // "button" type needs to be specified to prevent form submission
    return /*#__PURE__*/_react.default.createElement("button", (0, _extends2.default)({
      type: "button"
    }, props), msg);
  },
  div(props, msg) {
    return /*#__PURE__*/_react.default.createElement("div", props, msg);
  },
  h1(props, msg) {
    return /*#__PURE__*/_react.default.createElement("h1", props, msg);
  },
  h2(props, msg) {
    return /*#__PURE__*/_react.default.createElement("h2", props, msg);
  },
  h3(props, msg) {
    return /*#__PURE__*/_react.default.createElement("h3", props, msg);
  },
  h4(props, msg) {
    return /*#__PURE__*/_react.default.createElement("h4", props, msg);
  },
  h5(props, msg) {
    return /*#__PURE__*/_react.default.createElement("h5", props, msg);
  },
  h6(props, msg) {
    return /*#__PURE__*/_react.default.createElement("h6", props, msg);
  },
  h7(props, msg) {
    return /*#__PURE__*/_react.default.createElement("h7", props, msg);
  },
  img(props, msg) {
    return /*#__PURE__*/_react.default.createElement("img", (0, _extends2.default)({}, props, {
      alt: msg
    }));
  },
  li(props, msg) {
    return /*#__PURE__*/_react.default.createElement("li", props, msg);
  },
  link(props, msg) {
    return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, props, msg);
  },
  p(props, msg) {
    return /*#__PURE__*/_react.default.createElement("p", props, msg);
  },
  span(props, msg) {
    return /*#__PURE__*/_react.default.createElement("span", props, msg);
  },
  text(props, msg) {
    return /*#__PURE__*/_react.default.createElement("text", props, msg);
  },
  tspan(props, msg) {
    return /*#__PURE__*/_react.default.createElement("tspan", props, msg);
  }
};
class AutoIntl extends _react.PureComponent {
  static propTypes = {
    displayId: T.string,
    displayString: T.string,
    displayNumber: T.number,
    tag: T.oneOf((0, _keys.default)(elements)),
    values: T.object
  };
  static defaultProps = {
    tag: 'span'
  };
  renderElement(msg) {
    const filteredProps = filterProps(this.props, (0, _keys.default)(this.constructor.propTypes));
    const tag = elements[this.props.tag] ? this.props.tag : this.constructor.defaultProps.tag;
    return elements[tag](filteredProps, msg);
  }
  render() {
    const {
      displayId,
      displayNumber,
      displayString,
      values,
      children
    } = this.props;
    if (displayId) {
      return /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
        id: displayId,
        values: values,
        children: msg => this.renderElement(msg)
      });
    } else if (typeof displayNumber === 'number') {
      return /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedNumber, {
        value: displayNumber,
        children: formattedNumber => this.renderElement(formattedNumber)
      });
    } else {
      return this.renderElement(displayString || children);
    }
  }
}
exports.default = AutoIntl;